/**
 * NOTE: Optimizing image URL by converting them to webp formate for better performance
 * @param {String} imgUrl
 * @returns {String}
 */
export const imageUrlOptimizer = imgUrl => {
  if (
    imgUrl &&
    imgUrl.includes("graphassets.com") &&
    !imgUrl.includes("output=format:webp")
  ) {
    const parts = imgUrl.split("/")
    if (parts.length >= 5) {
      const domainPart = parts.slice(0, 3).join("/")
      const assetIdPart = parts[3]
      const remainingParts = parts.slice(4)

      const newSrc = `${domainPart}/${assetIdPart}/output=format:webp/${remainingParts.join(
        "/"
      )}`
      return newSrc
    }
  }
  // console.log(`Could not convert image, URL format not recognized:`, imgUrl)
  return imgUrl
}
